export const ErrorCodes = {
    required: 'is required',
    pattern: 'is invalid',
    invalidValue: 'is invalid',
    invalidName: 'is invalid',
    uniqueName: 'is not unique',
};
